import { render, staticRenderFns } from "./ImageQuestion.vue?vue&type=template&id=7ca5032a&scoped=true"
import script from "./ImageQuestion.vue?vue&type=script&lang=js"
export * from "./ImageQuestion.vue?vue&type=script&lang=js"
import style0 from "./ImageQuestion.vue?vue&type=style&index=0&id=7ca5032a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca5032a",
  null
  
)

export default component.exports